interface FloorplanUnit {
  id?: string;
  [key: string]: unknown;
}

interface Floorplan {
  units?: Array<FloorplanUnit>;
  [key: string]: unknown;
}

interface CurrentListing {
  isBuilding?: boolean;
  floorplans?: Array<Floorplan>;
  isApartmentBldg?: boolean;
  [key: string]: unknown;
}

interface ListingPageController {
  shouldShowMultiModels(currentListing?: CurrentListing | null): boolean;
}

const controller: ListingPageController = {
  shouldShowMultiModels(currentListing) {
    const isBuildingPage = Boolean(currentListing?.isBuilding);
    const currentFloorplans = !isBuildingPage && currentListing?.floorplans;
    const hasMultipleFloorplans = (currentFloorplans && currentFloorplans.length > 1) || false;
    const hasMultipleUnits =
      currentFloorplans && currentFloorplans.length && currentFloorplans[0].units
        ? currentFloorplans[0].units.length > 1
        : false;
    const isMfApartmentBldg = Boolean(currentListing?.isApartmentBldg);

    return (!isBuildingPage && (hasMultipleFloorplans || hasMultipleUnits)) || isMfApartmentBldg;
  },
};

export default controller;
